/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import NavbarDateInput from "../main/navbarInputs/navbarDateInput/NavbarDateInput";
import NavProfileIcon from "../shared/navProfileIcon/NavProfileIcon";
import NavNotificationBellIcon from "../shared/navNotificationIcon/NavNotificationBellIcon";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import LocationSearch from "../shared/locationSearch/LocationSearch";
import { toast } from "react-toastify";
import { base_url } from "../../config";

function Header({ setIsVisible }) {
  const accessToken = localStorage.getItem("@user");
  const navigate = useNavigate();
  useEffect(() => {
    const trigger = document.querySelector(".dropdown-trigger");
    const dropdown = document.querySelector(".dropdown");
    if (trigger && dropdown) {
      const handleTriggerClick = (event) => {
        dropdown.classList.toggle("hidden");
        event.stopPropagation();
      };

      const handleDocumentClick = (event) => {
        if (
          !dropdown.contains(event.target) &&
          !trigger.contains(event.target)
        ) {
          dropdown.classList.add("hidden");
        }
      };

      trigger.addEventListener("click", handleTriggerClick);
      document.addEventListener("click", handleDocumentClick);

      return () => {
        trigger.removeEventListener("click", handleTriggerClick);
        document.removeEventListener("click", handleDocumentClick);
      };
    }
  }, []);

  function formatDate(date) {
    if (date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    }
  }

  const [place, setPlace] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchText, setSearchText] = useState("");

  const handlePlaceInputChange = (event) => {
    setPlace(event.target.value);
  };
  const handleSearchTextInputChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleSubmit = async (event) => {
    if (!accessToken ) {
      alert("Please login to continue");
      setIsVisible(true);
      return;
    }
    if (place.length <= 0 && searchText.length <= 0 && !startDate) {
      toast.error("Please select an option!", {
        position: "top-center",
      });
      return;
    }
    event.preventDefault();

    const apiUrl = `${base_url}/tables/table-search`;

    const requestBody = {
      address: place,
      from: formatDate(startDate),
      to: formatDate(endDate),
      search: searchText,
    };

    try {
      const response = await axios.post(apiUrl, requestBody, {
        params: {
          access_token: accessToken,
          address: "puducherry",
        },
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("API Response is:", response.data);
      navigate("/searchresult", {
        state: {
          data: response.data,
          searchPayload: requestBody,
        },
      });
    } catch (error) {
      navigate("/searchresult", {
        state: { error: error.message, details: error.response?.data || null },
      });
    }
  };

  useEffect(() => {
    if (window.location.pathname === "/login" && !accessToken) {
      setTimeout(() => {
        setIsVisible(true);
      }, 1000); // Delay by 1 second
    } else if (window.location.pathname === "/login" && accessToken) {
      navigate("/");
    }
  }, []);

  return (
    <div className="navbar-no-shadow ">
      <div className="w-embed">
        <div
          data-animation="default"
          data-collapse="medium"
          data-duration={400}
          data-easing="ease"
          data-easing2="ease"
          role="banner"
          className="navbar-no-shadow-container w-nav"
        >
          <div className="container-regular">
            <div className="navbar-wrapper">
              <Link to="/" className="navbar-brand hide-mobile w-nav-brand">
                <img
                  loading="lazy"
                  src="/images/Frame-1.svg"
                  alt="Hightable_logo"
                  className="hightable-logo"
                />
              </Link>
              <Link to="/" className="navbar-brand hide-desktop w-nav-brand">
                <img
                  loading="lazy"
                  src="/images/symbolic_logo-1.svg"
                  alt="Hightable_logo"
                  className="hightable-logo"
                />
              </Link>
              <div className="navbar_searchbox font-size">
                <div className="form-block w-form">
                  <form
                    id="email-form"
                    name="email-form"
                    data-name="Email Form"
                    method="get"
                    className="form"
                    data-wf-page-id="67432a5d4dafa20e3890e283"
                    data-wf-element-id="8a23e3a0-0bf3-850e-05da-75357fc8f4b0"
                  >
                    <LocationSearch
                      place={place}
                      handlePlaceInputChange={handlePlaceInputChange}
                    />

                    {/* <div className="navbar_form--checkin when">
                                        <label htmlFor="date-2" className="field-label-3">
                                            When
                                        </label>
                                        <input
                                            className="navbar_form--textfield daterange w-input"
                                            autoComplete="off"
                                            maxLength={256}
                                            name="date-2"
                                            data-name="Date 2"
                                            placeholder="Search dates"
                                            type="text"
                                            id="date-2"
                                        />
                                        <div className="placeholder">Add dates</div>
                                    </div> */}
                    <NavbarDateInput
                      setEndDate={setEndDate}
                      setStartDate={setStartDate}
                      startDate={startDate}
                      endDate={endDate}
                    />
                    <div className="navbar_form--checkin">
                      <label htmlFor="Dates-3" className="field-label-3">
                        What
                      </label>
                      <input
                        className="navbar_form--textfield w-input"
                        maxLength={256}
                        name="Dates-2"
                        data-name="Dates 2"
                        placeholder="Search Tables, hosts ..."
                        type="text"
                        id="Dates-2"
                        value={searchText} // Bind state to input value
                        onChange={handleSearchTextInputChange}
                      />
                      <div className="placeholder">Add guests</div>
                    </div>
                    <a
                      data-w-id="8a23e3a0-0bf3-850e-05da-75357fc8f4ed"
                      href="#"
                      className="link-block w-inline-block"
                      onClick={handleSubmit}
                    >
                      <div className="navbar_form--button_wrapper with-search">
                        <div className="arrow">
                          <img
                            loading="lazy"
                            src="/images/search_rounded.svg"
                            alt=""
                            className="navbar_form--button_arrow"
                          />
                        </div>
                        <div
                          data-w-id="8a23e3a0-0bf3-850e-05da-75357fc8f4f1"
                          className="searchtext hide-text"
                        >
                          Search
                        </div>
                      </div>
                    </a>
                  </form>
                  <div className="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div className="w-form-fail">
                    <div>
                      Oops! Something went wrong while submitting the form.
                    </div>
                  </div>
                </div>
              </div>
              <nav role="navigation" className="nav-menu-wrapper w-nav-menu">
                <ul role="list" className="nav-menu w-list-unstyled">
                  <li className="mobile-margin-top-10">
                    <div className="nav-button-wrapper">
                      <div className="nav-button nav-icon" />
                      <div
                        data-delay={300}
                        data-hover="true"
                        data-w-id="8a23e3a0-0bf3-850e-05da-75357fc8f500"
                      >
                        {/* <div className="navbar_dropdown-toggle w-dropdown-toggle">
                        <div className="nav-icon">
                          <div className="user notification" />
                        </div>
                      </div> */}
                        {accessToken ? <NavNotificationBellIcon /> : null}
                      </div>
                      <div
                        data-delay={300}
                        data-hover="true"
                        data-w-id="8a23e3a0-0bf3-850e-05da-75357fc8f54c"
                        className="navbar_menu-dropdown w-dropdown"
                      >
                        <NavProfileIcon setIsVisible={setIsVisible} />
                      </div>
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
